<template>
  <v-card elevation="5">
    <a :href="service.url">
      <v-img :src="require(`@/assets/${image}`)" />
    </a>
    <v-card-title :class="'darken-2 white--text mb-4 ' + color + ' darken-2'">
      <a :href="service.url" class="white--text" style="text-decoration: none">{{ service.name }}</a>
    </v-card-title>
    <v-card-text>
      <p v-text="service.description" />
      <div :class="'text--darken-2 ' + color + '--text'">Starting at</div>
      <h5 :class="'text-h5 text--darken-2 ' + color + '--text'">
        <strong>${{ service.price_new || service.price }}</strong>/mo.
      </h5>
    </v-card-text>
    <v-card-actions>
      <v-btn text tile :href="service.url" target="_blank" :color="color + ' darken-2'">
        <v-icon left>mdi-launch</v-icon>Learn more
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ServiceCard",

  props: ["service"],

  data: () => ({}),

  methods: {},
  computed: {
    color() {
      switch (this.service.service_type) {
        case "internet":
          return "blue";
        case "tv":
          return "orange";
        case "managed_wifi":
          return "green";
        default:
          return "blue";
      }
    },
    image() {
      switch (this.service.service_type) {
        case "internet":
          return "internet-card-header.jpg";
        case "tv":
          return "tvnow-card-header.jpg";
        case "managed_wifi":
          return "managed-wifi-card-header.jpg";
        default:
          return "internet-card-header.jpg";
      }
    }
  }
};
</script>
